import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import Row from 'components/Layout/Row';
import Button from 'components/Button';
import Icon from 'components/Icon';

import { getFirebaseAuthError } from 'utils';

const LoginForm = ({ error, loginUser, loading, isShare, isSumoLing }) => {
  const [persist, setPersist] = useState(true);
  const [user, setUser] = useState({ email: '', password: '' });
  const [showPassword, setShowPassword] = useState(false);

  const persistChangeHandler = () => {
    setPersist((state) => !state);
  };

  const inputHandler = (e) => {
    const { name, value } = e.target;

    setUser({ ...user, [name]: value });
  };

  const handleSubmit = (e) => {
    const successURL =
      new URL(window.location).searchParams.get('goto') || '/projects';

    e.preventDefault();
    loginUser({
      email: user.email,
      password: user.password,
      successURL,
      persist,
    });
  };

  const switchPasswordHandler = () => {
    setShowPassword((state) => !state);
  };

  return (
    <form
      onSubmit={handleSubmit}
      className={`users-form${isShare ? ' is-share' : ''}`}>
      {error && error.code && (
        <div className="mb-1 error">
          <Icon
            name="warning"
            verticalAlign="middle"
            height="20px"
            width="20px"
          />
          <span>{getFirebaseAuthError(error.code)}</span>
        </div>
      )}
      <div className="mb-2">
        <label htmlFor="email">
          Email Address
          <br />
          <input
            type="email"
            name="email"
            id="email"
            placeholder="Enter email address"
            value={isSumoLing || user.email}
            onChange={inputHandler}
            required
            // eslint-disable-next-line jsx-a11y/no-autofocus
            autoFocus
            autoComplete="username"
            disabled={isSumoLing}
          />
        </label>
      </div>
      <div className="mb-1">
        <label htmlFor="password" className="password-field">
          Password
          <br />
          <input
            type={showPassword ? 'text' : 'password'}
            name="password"
            id="password"
            placeholder="Enter your password"
            value={user.password}
            onChange={inputHandler}
            required
            autoComplete="current-password"
          />
          <Button
            type="button"
            onClick={switchPasswordHandler}
            style={isShare ? { top: 35 } : {}}>
            <Icon
              name={showPassword ? 'view-off' : 'view'}
              width={showPassword ? '19px' : '18px'}
            />
          </Button>
        </label>
      </div>
      <Row justify="space-between" style={{ margin: '0 0 15px' }}>
        <label htmlFor="persist">
          <input
            type="checkbox"
            name="persist"
            id="persist"
            checked={persist}
            onChange={persistChangeHandler}
            style={{ width: 'auto' }}
          />
          Remember me
        </label>
        {!isSumoLing && (
          <Link to="/forgot-password" className="link">
            Forgot password?
          </Link>
        )}
      </Row>
      <Button type="submit" disabled={loading}>
        {loading ? 'Logging in...' : 'Sign in'}
      </Button>
    </form>
  );
};

LoginForm.propTypes = {
  loading: PropTypes.bool.isRequired,
  error: PropTypes.object.isRequired,
  loginUser: PropTypes.func.isRequired,
  isShare: PropTypes.bool,
  isSumoLing: PropTypes.oneOfType([PropTypes.bool, PropTypes.string])
    .isRequired,
};

export default LoginForm;
